/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Whether this cell differs from the previous edition. Derived for every row, independent of rowStatus — a dropped row still marks a changed job mapping.
 */
export enum SurveyReplacementReviewDiffChangeType {
    UNCHANGED = 'unchanged',
    CHANGED = 'changed',
    NEW = 'new',
}
